import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ChartSeriesModel } from '../typings/chart-series';

// Series swatches as toggle buttons; the caller owns which keys are hidden and re-renders on toggle
@Component({
  selector   : 'wor-chart-legend',
  styles: [ require('./chart-legend.component.scss') ],
  template: require('./chart-legend.component.html')
})
export class ChartLegendComponent {
  @Input() hiddenKeys : Array<string>           = [];
  @Input() series     : Array<ChartSeriesModel> = [];

  @Output() toggled : EventEmitter<string> = new EventEmitter<string>();

  isHidden ( key : string ) : boolean {
    return this.hiddenKeys.indexOf(key) > -1;
  }

  trackSeries ( index : number, item : ChartSeriesModel ) : string {
    return item.key;
  }
}
